import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    aluno: {},
    cfc: {},
  },
  getters: {
    getCfc: state => state.cfc,
    getAluno: state => {
      return state.aluno;
    }
  },
  mutations: {
    updateCfc(state, Cfc) {
      state.cfc = Cfc;
    },
    updateAluno(state, aluno) {
      state.aluno = aluno;
    },
  },

});
